import { useNavigate } from "react-router-dom";
import { useRuns } from "../api/queries";

const order = (s: string) => (s === "running" ? 0 : 1);

// Run picker for the dashboard: running runs first (ordered by GPU, GPU0 first),
// then most-recent. Switching navigates to /runs/:name so the dashboard re-points.
export function RunSelector({ selected }: { selected: string }) {
  const { data } = useRuns();
  const nav = useNavigate();
  const runs = [...(data ?? [])].sort((a, b) =>
    order(a.status) - order(b.status)
    || (a.gpu_id ?? Infinity) - (b.gpu_id ?? Infinity)
    || b.mtime - a.mtime);

  return (
    <select className="run-select" value={selected}
      onChange={(e) => nav(`/runs/${encodeURIComponent(e.target.value)}`)}>
      {selected === "" && <option value="">— select a run —</option>}
      {runs.map((r) => (
        <option key={r.name} value={r.name}>
          {r.status === "running" ? "● " : ""}{r.name}
          {r.best_fitness != null ? `  ·  ${r.best_fitness.toFixed(3)}` : ""}
        </option>
      ))}
    </select>
  );
}
